import * as angular from 'angular';
import { IUndockedViewProxy, ExternalViewProxy } from '@common/preview/preview.shared';
import { ExternalView } from '@common/preview/externalpreview';
import { IWindowBounds } from '@common/infoma.environment';
import { IKWFRoute } from './KWFMain';
import { CompatibilityService } from '@common/services/compatibilityservice';
import { fn } from '@common/utils';

interface ISPAProxy extends IUndockedViewProxy {
    ChangeRoute(route: string);

    SendObject(name: string, data: any);
}

// Current Runtime is Externally Controlled
export function IsExternalControlled() {
    return IsExternalProxy;
}
const Instances: { [nameToken: string]: SPAProxyController } = {};
var IsExternalProxy: SPAProxyImp;
export interface ISPAOpenExtInfo {
    Ctrl: SPAProxyController,
    OpenExt: boolean | PromiseLike<boolean>
}

type IWindowBoundsInfos = IWindowBounds | PromiseLike<IWindowBounds> | (() => IWindowBounds | PromiseLike<IWindowBounds>);
export class SPAProxyController extends ExternalView<ISPAProxy> {
    /** Try to Create a Slave SPA Instance in seperate window ... */
    public static TryInstantiate($c: CompatibilityService, nameToken: string, windowBounds?: IWindowBoundsInfos) {
        if (nameToken && !IsExternalControlled()) {
            return Instances[nameToken] || (Instances[nameToken] = new SPAProxyController($c, nameToken, windowBounds));
        }
    }

    constructor($c: CompatibilityService, name: string, private windowBounds?: IWindowBoundsInfos) {
        super(name, () => `./#/${SPAProxyImp.RouteName}/` + name + "?" +
            fn.EncodeQueryData({ company: $c.resolve("Rwf")("RwfBootstrap").EnsureResolved().NavUrlInfo.Mandant }));
    }

    public static OnMessage(name: string, callback: ((data: any) => void)) {
        return angular.element(document.documentElement).injector().get("$rootScope").$on(RwfProxyMessage, (e, evName: string, args: any) => {
            if (evName == name)
                callback(args);
        });
    }

    private async waitActive() {
        if (!this.IsActive) {
            this.IsActive = true;
        }
        try {
            if (typeof this.windowBounds == "function")
                var windowBounds = this.windowBounds();
            else
                windowBounds = this.windowBounds;
        } catch (Err) { }
        return this.EnsureAlive(await windowBounds)
    }
    async ChangeRoute(route: string) {
        return (await this.waitActive()).ChangeRoute(route);
    }

    async SendObject(name: string, data: any) {
        return (await this.waitActive()).SendObject(name, data);
    }
}

/** Initial Route to initialiize as Slave */
export class SPAProxyImp extends ExternalViewProxy implements ISPAProxy {

    static RouteName = "spa";
    static Route: IKWFRoute = {
        HideBar: false,
        DescriptionFormula: "'Externe Ansicht ...'",
        template: "<div></div>",
        controller: SPAProxyImp,
        resolve: {
            "extid": ["$route", ($route: ng.route.IRouteService) => $route.current.params["extid"]],
        }
    };
    static $inject = ["$location", "$rootScope", "extid"];
    constructor(private $location: ng.ILocationService, private $rootScope: ng.IScope, extid) {
        super(extid, true);
        IsExternalProxy = this;
    }

    ChangeRoute(route: string) {
        route = route.replace('/#/', '/');
        this.$location.path(route);
        this.$rootScope.$applyAsync();
    }

    SendObject(message: string, data: any) {
        const $rootScope = this.$rootScope;
        $rootScope.$emit(RwfProxyMessage, message, data);
        $rootScope.$applyAsync();
    }
}

const RwfProxyMessage = "RwfProxyMessage";

